import { apiJson } from './client'

export type ProfFeedbackSignal = 'useful' | 'confusing'
export interface ProfFeedbackRow {
  messageId: string
  signal: ProfFeedbackSignal
  updatedAt: string
}

export const profFeedbackApi = {
  list(sessionId: string): Promise<{ feedback: ProfFeedbackRow[] }> {
    return apiJson(`/api/prof-feedback?sessionId=${encodeURIComponent(sessionId)}`)
  },
  upsert(messageId: string, signal: ProfFeedbackSignal): Promise<{ feedback: ProfFeedbackRow }> {
    return apiJson(`/api/prof-feedback/${encodeURIComponent(messageId)}`, {
      method: 'PUT', body: JSON.stringify({ signal }),
    })
  },
  remove(messageId: string): Promise<{ removed: true }> {
    return apiJson(`/api/prof-feedback/${encodeURIComponent(messageId)}`, { method: 'DELETE' })
  },
}
